import React from 'react'
import { usePositionsContextValue } from '../../context/PositionsProvider'
import { useSelectedColumns } from './ColumnsFilter/useSelectedColumns'
import { PaginatedTable } from 'components/Table/PaginatedTable'

export const PositionsTable = () => {
  const {
    state: { data, pagination, isFetching },
    actions: { setPagination },
  } = usePositionsContextValue()

  const columns = useSelectedColumns()
  return (
    <PaginatedTable
      columns={columns}
      items={data.items}
      rowCount={data.totalRows}
      pagination={pagination}
      setPagination={setPagination}
      isFetching={isFetching}
      emptyMessage="No positions matched your search. Try using different filters."
      emptyStateMaxWidth={['100%', '100%', '50%', '50%']}
    />
  )
}
